import { useCallback, useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { api, setJumboTypes } from "@/lib/dimsum";
import { Navbar } from "@/components/Navbar";
import { RecapForm } from "@/components/RecapForm";
import { InputLembur } from "@/components/InputLembur";
import { Laporan } from "@/components/Laporan";
import { History } from "@/components/History";
import { GajiPeserta } from "@/components/GajiPeserta";
import { Teams } from "@/components/Teams";
import { KelolaBarang } from "@/components/KelolaBarang";
import { Pinjaman } from "@/components/Pinjaman";

function App() {
  const [tab, setTab] = useState("input");
  const [teams, setTeams] = useState([]);
  const [dimsumTypes, setDimsumTypes] = useState([]);
  const [doughTypes, setDoughTypes] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminUser, setAdminUser] = useState(null);

  const bump = useCallback(() => setRefreshKey((k) => k + 1), []);

  const loadTeams = useCallback(() => {
    api.get("/teams").then((r) => setTeams(r.data));
  }, []);

  const loadTypes = useCallback(() => {
    api.get("/dimsum-types").then((r) => setDimsumTypes(r.data));
    api.get("/dough-types").then((r) => {
      setDoughTypes(r.data);
      setJumboTypes((r.data || []).filter((d) => d.is_jumbo).map((d) => d.code));
    });
  }, []);

  useEffect(() => {
    loadTeams();
    loadTypes();
  }, [loadTeams, loadTypes]);

  useEffect(() => {
    if (!localStorage.getItem("admin_token")) return;
    api
      .get("/auth/me")
      .then((r) => {
        setIsAdmin(true);
        setAdminUser(r.data);
      })
      .catch(() => localStorage.removeItem("admin_token"));
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("admin_token", data.token);
    setIsAdmin(true);
    setAdminUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem("admin_token");
    setIsAdmin(false);
    setAdminUser(null);
    setTab((cur) => (cur === "teams" ? "dashboard" : cur));
  };

  const onTeamsChanged = () => {
    loadTeams();
    bump();
  };

  const adminOnly = tab === "teams" || tab === "pinjaman";
  const masterOnly = tab === "barang";
  const isMaster = adminUser?.role === "master";
  const effectiveTab =
    (!isAdmin && adminOnly) || (!isMaster && masterOnly) ? "dashboard" : tab;

  return (
    <div className="App min-h-screen">
      <Toaster position="top-center" richColors />
      <Navbar
        active={effectiveTab}
        onChange={setTab}
        isAdmin={isAdmin}
        adminUser={adminUser}
        onLogin={login}
        onLogout={logout}
      />
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-6 sm:py-10">
        {effectiveTab === "input" && (
          <RecapForm teams={teams} dimsumTypes={dimsumTypes} doughTypes={doughTypes} onSaved={bump} />
        )}
        {effectiveTab === "lembur_input" && (
          <InputLembur teams={teams} doughTypes={doughTypes} isAdmin={isAdmin} onSaved={bump} />
        )}
        {effectiveTab === "dashboard" && <Laporan refreshKey={refreshKey} isAdmin={isAdmin} adminUser={adminUser} />}
        {effectiveTab === "history" && (
          <History teams={teams} refreshKey={refreshKey} onChanged={bump} isAdmin={isAdmin} />
        )}
        {effectiveTab === "gaji" && <GajiPeserta refreshKey={refreshKey} teams={teams} adminUser={adminUser} onChanged={bump} />}
        {effectiveTab === "teams" && isAdmin && <Teams teams={teams} onChanged={onTeamsChanged} />}
        {effectiveTab === "pinjaman" && isAdmin && <Pinjaman teams={teams} isMaster={isMaster} />}
        {effectiveTab === "barang" && isMaster && <KelolaBarang onChanged={loadTypes} />}
      </main>
    </div>
  );
}

export default App;
